import * as React from "react";
import { GridColumnMenuProps } from "@progress/kendo-react-grid";
import { GridColumnMenuCheckboxFilter } from "@progress/kendo-react-grid";

export const ColumnMenuCheckboxFilter = (
	props: GridColumnMenuProps & { data: any[] },
) => {
	const field = props.column.field;
	const sortedData = React.useMemo(() => {
		if (!field) {
			return props.data;
		}

		return [...props.data].sort((firstItem, secondItem) => {
			const firstValue = firstItem[field];
			const secondValue = secondItem[field];

			if (firstValue == null) return 1;
			if (secondValue == null) return -1;

			if (typeof firstValue === "string" && typeof secondValue === "string") {
				return firstValue.localeCompare(secondValue, "nb-NO", {
					sensitivity: "base",
					numeric: true,
				});
			}

			return firstValue < secondValue ? -1 : firstValue > secondValue ? 1 : 0;
		});
	}, [props.data, field]);

	return (
		<div>
			<GridColumnMenuCheckboxFilter
				{...props}
				expanded={true}
				data={sortedData}
			/>
		</div>
	);
};
